var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4839 3.45161L8.87097 7.06452L5.25806 8.41935L3.90323 9.77419L10.2258 16.0968L11.5806 14.7419L12.9355 11.129L16.5484 7.51613",
    fill: "#59BD39",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4839 3.45161L8.87097 7.06452L5.25806 8.41935L3.90323 9.77419L10.2258 16.0968L11.5806 14.7419L12.9355 11.129L16.5484 7.51613M7.06452 12.9355L3 17M12.0323 3L17 7.96774",
    stroke: "#59BD39",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinFill);
export default ForwardRef;